export default __webpack_public_path__ + "static/media/alertes-1.030a4be1.png";